package com.nonopn.skywatcher.app.utils

actual object AuthentInit {
    actual fun initialize() {
        // nothing
    }
}
